import React from 'react'

import { useDecision } from '@optimizely/react-sdk'

import { useBasket } from 'routes/Menu/domains/basket'

import { Welcome } from './Welcome'

const WelcomeWrapper = (ownProps: any) => {
  const { addRecipe } = useBasket()
  const [signUpFirstTwoBoxesExperiment] = useDecision(
    'rockets_seamless_flow_into_planning_experiment',
  )
  const isSignUpSeamlessFlowIntoPlanningEnabled =
    signUpFirstTwoBoxesExperiment.variationKey === 't1'

  return (
    <Welcome
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...ownProps}
      addRecipeToBasket={addRecipe}
      isSignUpSeamlessFlowIntoPlanningEnabled={isSignUpSeamlessFlowIntoPlanningEnabled}
    />
  )
}

export { WelcomeWrapper }
